import * as React from 'react';
import '@styles/pages/tab3.scss';
import RankHeader from '@hook/public/rankHeader.tsx';
import Page from '@hook/public/page.tsx';
import MasterItem from '@hook/Tab3//masterItem.tsx';
import NoneData from '@hook/public/none.tsx';
import { fetch, TycoonRankRsp, RankItem } from '@/fetch.ts';
interface Props {
  iArea: number,
  name: string,
}
const { useState, useEffect } = React;

const Master: React.FC<Props> = props => {
  const [list, List] = useState<RankItem[]>([]);
  const [showList, ShowList] = useState<RankItem[]>([]);
  const pageChange = (index: number): void => {
    ShowList(list.slice((index) * 10, (index + 1) * 10 >= list.length ? list.length : (index + 1) * 10));
  }
  useEffect(() => {
    fetch.getTycoonRank(
      {
        iArea: props.iArea,
      },
    )
      .then((rsp: TycoonRankRsp) => {
        List(rsp.vRankList.value.slice(0, 50));
        ShowList(rsp.vRankList.value.length > 10 ? rsp.vRankList.value.slice(0, 10) : rsp.vRankList.value);
      })
  }, [])
  return (
    <div className='master'>
      <h1 className='title'>
        {props.name}神豪榜
      </h1>
      <RankHeader
        width={860}
        color='#519ff7'
        prev='排名'
        mid='神豪昵称'
        next='贡献值'
      />
      <div className='masterList'>
        {
          showList.length !== 0 ?
            showList.map((item: RankItem) => (
              <MasterItem {...item} key={item.lUid} />
            )) :
            <NoneData text={'暂无神豪榜数据'} />
        }
      </div>
      <Page
        pageLen={list.length % 10 === 0 ? list.length / 10 : Math.floor(list.length / 10) + 1}
        setPageIndex={pageChange}
      />
    </div>
  );
}

export default Master;